export default __webpack_public_path__ + "static/media/s007.0807c4d5.jpeg";